
import React, { PureComponent } from 'react'
import autobind from 'autobind-decorator'

import Controller from '../FormsController'

export default class Question2 extends PureComponent {

  componentDidMount() {
    this.refs.input.click()
  }

  render() {
    return (
      <div>
        <form
          id='form139'
          name='form139'
          acceptCharset='UTF-8'
          autoComplete='off'
          encType='multipart/form-data'
          method='post'
          noValidate
          action='https://adagency.wufoo.com/forms/zy3cbiu1vvtuw5/#public'
          onClick={this.props.onClick}
          >
          <span style={{ display: 'none' }}>
            <label id='title12' htmlFor='Field12'>Full Name</label>
            <input id='Field12' name='Field12' type='text' value={Controller.fullname} readOnly />

            <label id='title13' htmlFor='Field13'>Email</label>
            <input id='Field13' name='Field13' type='email' value={Controller.email} readOnly />

            <label id='title15' htmlFor='Field15'>Message</label>
            <textarea id='Field15' name='Field15' spellCheck='true' readOnly>{Controller.message.answer}</textarea>

            <label htmlFor='comment'>Do Not Fill This Out</label>
            <textarea name='comment' id='comment' readOnly />
            <input type='hidden' id='idstamp' name='idstamp' value='7EW/u6sNA3sQud5GH3X9H1MllHH+RkrwQjLs17g2EPo=' />
            <input id='saveForm' name='saveForm' value='Submit' type='submit' ref='input' />
          </span>
        </form>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/Survey/Submit/Submit.js
 **/